module.exports = __webpack_public_path__ + "img/Turkey.7fade636.jpg";